import { render, staticRenderFns } from "./trust-deed-form.vue?vue&type=template&id=93a0c3da"
import script from "./trust-deed-form.vue?vue&type=script&lang=js"
export * from "./trust-deed-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports